export default "__VITE_ASSET__DKUbvEu4__"